// `Username` — a player's gamer tag (spec/12 §3.3, spec/04 §2, issue #43 rule 2).
//
// "Username 3–20 chars, letters, digits, `_` and `.`; unique; suggestions offered." Unique ignoring
// case — `player_profile.username` is `citext` — so `Rohan_I` and `rohan_i` are one tag. The kiosk,
// the apps and the server all validate with this, so a tag the kiosk accepts is one the server does.
import { z } from "../zod.js";
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_PATTERN = /^[A-Za-z0-9_.]+$/;
export function isUsername(value) {
    return (typeof value === 'string' &&
        value.length >= USERNAME_MIN_LENGTH &&
        value.length <= USERNAME_MAX_LENGTH &&
        USERNAME_PATTERN.test(value));
}
export const UsernameSchema = z
    .string()
    .min(USERNAME_MIN_LENGTH)
    .max(USERNAME_MAX_LENGTH)
    .regex(USERNAME_PATTERN, 'Letters, digits, "_" and "." only')
    .openapi('Username', { description: 'A gamer tag: 3–20 letters, digits, "_" or ".". Unique, ignoring case.', example: 'rohan_i' });
//# sourceMappingURL=username.js.map